import { Component, Input, OnInit } from '@angular/core';
import { Transport, TransportTaskStatus } from 'src/tmc-yard/common/model/transport.model';
import { CTransportTaskState } from 'src/tmc-yard/components/transport-details/transport-details-model';

@Component({
  selector: 'app-planned-assignment-list-entry',
  templateUrl: './planned-assignment-list-entry.component.html',
  styleUrls: ['./planned-assignment-list-entry.component.scss']
})
export class PlannedAssignmentListEntryComponent implements OnInit {

  @Input()
  transportDetails: Transport;

  TransportTaskStatus = TransportTaskStatus;

  @Input()
  selected: boolean;

  constructor() { }

  ngOnInit(): void {
  }

}
